import * as types from 'store/actions/types';
import services from 'services/services';

// Import helpers
import { checkErrorStatus } from '../../helpers/error_status';
import { getImage } from 'helpers';

// NOTIFICATIONS
import { openNotification } from 'components/utilities/notification/notification';
import i18next from 'i18next';

// Import variables
import { PRODUCT_IMAGES_TYPES } from 'helpers/variables';

const { COVER_LARGE } = PRODUCT_IMAGES_TYPES;

/**
 * this action is responsible for fetch and save sections for given
 * group
 * @param {string} groupLabel
 * @param {function} dispatch
 * @returns {*}
 */
export async function getSectionGroups(groupLabel, dispatch) {
	try {
		dispatch({ type: types.SECTION_GROUPS_LOADING, groupLabel });

		const url = `/sections/page/${groupLabel}`;

		const { data: sections } = await services.get(url);

		const initialLocation = window.location.pathname;

		for (let section of sections) {
			const newLocalization = window.location.pathname;
			if (initialLocation === newLocalization) {
				await fetchSectionContent({
					section,
					dispatch,
					groupLabel,
					initialLocation
				});
			} else {
				break;
			}
		}
		dispatch({ type: types.SECTION_GROUPS_LOADING_FINISH, groupLabel });
	} catch (error) {
		dispatch({ type: types.SECTION_GROUPS_ERROR, groupLabel });
		checkErrorStatus(error) &&
			openNotification({
				type: 'error',
				title: i18next.t('common_general_error'),
				description: i18next.t('sections_group_error_description')
			});
	}
}

const fetchSectionContent = async ({ section, dispatch, groupLabel, initialLocation }) => {
	const { id, main_limit, name, type, label, images } = section;
	const sectionUrl = `/sections/${id}/content?offset=0&limit=${main_limit}`;

	const {
		data: { data: content }
	} = await services.get(sectionUrl);

	const backgroundImage = getImage({ images, types: [COVER_LARGE] });

	const newLocalization = window.location.pathname;

	if (initialLocation === newLocalization) {
		dispatch({
			type: types.SECTION_GROUPS_SUCCESS,
			payload: { name, id, content, type, label, backgroundImage },
			groupLabel
		});
	}
};

export async function clearSectionGroups(dispatch) {
	dispatch({
		type: types.SECTION_GROUPS_CLEAR,
		payload: true
	});
}
